import React from "react";
import { Popover, Tooltip, Typography } from "antd";
import {
    InfoCircleOutlined,
    ExclamationCircleOutlined,
    CheckCircleOutlined,
    LoadingOutlined,
} from "@ant-design/icons";

// Pure — reproduces renderGPSFlagChecklist. `criteria` from mappers/gpsCriteria.
// `loading`: the flag metadata is still being fetched — show a spinner instead of the checklist
// so a fast click → info-button open never shows criteria built from not-yet-loaded data.
export const GpsFlagChecklist = ({ criteria, loading = false }) => {
    if (loading) {
        return (
            <div className="stv2-flag-helper-container">
                <Tooltip title="Loading GPS flag details…">
                    <LoadingOutlined spin style={{ fontSize: 20, color: "#000000" }} />
                </Tooltip>
            </div>
        );
    }

    const allMet = criteria.every((item) => item.condition === true);
    const btnColor = allMet ? "#ff8000" : "#000000";

    const getIcon = (condition) =>
        condition ? (
            <CheckCircleOutlined style={{ color: "#cccccc", marginRight: "5px", fontSize: 15 }} />
        ) : (
            <ExclamationCircleOutlined style={{ color: "#ff8000", marginRight: "5px", fontSize: 15 }} />
        );

    const content = (
        <span>
            <div>
                <Typography.Title level={5}>GPS Flag Checklist</Typography.Title>
                {criteria.map((item, index) => (
                    <React.Fragment key={index}>
                        {getIcon(item.condition)}
                        <Typography.Text disabled={item.condition} delete={item.condition}>
                            {item.condition ? item.true_text : item.false_text}
                        </Typography.Text>
                        <br />
                    </React.Fragment>
                ))}
            </div>
        </span>
    );

    return (
        <div className="stv2-flag-helper-container">
            <Popover placement="leftTop" content={content} trigger="click">
                <InfoCircleOutlined style={{ fontSize: 20, color: btnColor }} />
            </Popover>
        </div>
    );
};
